interface BrandNameProps {
  size?: 'default' | 'large';
  color?: string;
}

export function BrandName({ size = 'default', color = 'var(--mantine-color-text)' }: BrandNameProps) {
  const large = size === 'large';

  return (
    <span
      style={{
        display: 'grid',
        lineHeight: 0.9,
        color,
      }}
    >
      <span
        style={{
          fontFamily: "'Source Sans 3 Variable', 'Segoe UI', sans-serif",
          fontSize: large ? '0.75rem' : '0.62rem',
          fontWeight: 600,
          lineHeight: 1,
          letterSpacing: '0.12em',
          textTransform: 'uppercase',
        }}
      >
        the
      </span>
      <strong
        style={{
          fontFamily: "'Sora Variable', 'Trebuchet MS', sans-serif",
          fontSize: large ? '1.5rem' : '1rem',
          fontWeight: 600,
          lineHeight: 0.9,
          letterSpacing: '-0.04em',
          whiteSpace: 'nowrap',
        }}
      >
        Game Project
      </strong>
    </span>
  );
}
